import React, { useContext } from 'react';
import { FormComponent } from '../../../Form/FormComponent';
import { CustomCheckbox } from '../../../Form/CustomCheckBox';
import {
  InitialFeedbackPrefDataType,
  InitialFeedbackPrefSchema,
  initialFeedbackPrefInitialValues,
} from '../../../../models/preference/feedbackformpreference.model';
import styled from '@emotion/styled';
import ValidatingFormSubmitButton from '../../../Button/FormSubmitButton';
import { ModalContext } from '../../../../context/ModalContext';
import useUpdateMonthlyFeedbackPrompt from '../../../../hooks/prompts/useUpdateMonthlyFeedbackPrompt';

const MonthlyFeedBackGrandChild = () => {
  const { displayModal } = useContext(ModalContext)!;

  const { updateMonthlyFeedbackPrompt, loading } =
    useUpdateMonthlyFeedbackPrompt();

  const handleSubmit = async (values: InitialFeedbackPrefDataType) => {
    await updateMonthlyFeedbackPrompt(values);
    displayModal(false);
  };

  return (
    <FormComponent
      initialValues={initialFeedbackPrefInitialValues}
      schema={InitialFeedbackPrefSchema}
      onSubmit={handleSubmit}
    >
      <Div>
        {' '}
        <CustomCheckbox name="showInitialFeedbackPrompt" noError manual /> Do
        not show me this message again
      </Div>
      <Div2>
        {' '}
        <ValidatingFormSubmitButton className="small" loading={loading}>
          SUBMIT
        </ValidatingFormSubmitButton>
      </Div2>
    </FormComponent>
  );
};

export default MonthlyFeedBackGrandChild;

const Div = styled.div`
  display: flex;
`;

const Div2 = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;
